import { ReactElement, ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

interface ILayoutProps {
  className?: string;
  wrapClassName?: string;
  small?: boolean;
  secondaryColor?: boolean;
  children: ReactElement | ReactNode;
}

export function Card({
  className,
  wrapClassName,
  small = false,
  secondaryColor = false,
  children,
}: ILayoutProps): ReactElement {
  const { classes, cx } = useStyles({
    isSmall: small,
    isSecondaryColor: secondaryColor,
  });

  return (
    <div className={cx(classes.root, className)}>
      <div className={cx(classes.wrap, wrapClassName)}>{children}</div>
    </div>
  );
}

const useStyles = makeStyles<{ isSmall: boolean; isSecondaryColor: boolean }>()(
  (theme, { isSmall, isSecondaryColor }) => ({
    root: {
      height: 'inherit',
      borderRadius: 12,
      padding: theme.spacing(0.5),
      background: isSecondaryColor
        ? theme.palette.background.default
        : `linear-gradient(${isSmall ? '170deg' : '147deg'}, ${theme.palette.secondary.light} 3.74%, ${theme.palette.primary.main} 7.03%, ${theme.palette.secondary.main} 12.22%, ${theme.palette.secondary.dark} 25.76%, ${theme.palette.background.default} 41.68%)`,
    },
    wrap: {
      height: '100%',
      borderRadius: 12,
      padding: theme.spacing(6),
      background: isSecondaryColor
        ? theme.palette.primary.contrastText
        : `linear-gradient(110.01deg, ${theme.palette.background.default} 8.7%, ${theme.palette.primary.contrastText} 40.24%)`,

      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(4),
      },
    },
  }),
);
